import { render, staticRenderFns } from "./SchoolsMap.vue?vue&type=template&id=63e71538&scoped=true&"
import script from "./SchoolsMap.vue?vue&type=script&lang=js&"
export * from "./SchoolsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e71538",
  null
  
)

export default component.exports